import {StaticTable} from './static.table';
import {SyncTime} from '../interfaces/core/sync-time';
import {Injectable} from '@angular/core';
import {SyncTimeFactory} from '../factories/core/sync-time-factory';
import {TableName} from '../enums/core/table-name';
import {Table} from 'dexie';
import {db} from './db.service';
import {DateTime} from 'luxon';

@Injectable({
  providedIn: 'root'
})
export abstract class SyncTimesStaticTable<T extends { id: number }> extends StaticTable<T> {

  private _syncTime: SyncTime = null;
  private readonly _syncTimesTable: Table<SyncTime, number> = db.syncTimes;

  /**
   *
   * @param table
   * @protected
   */
  protected constructor(table: Table<T, number>) {
    super(table);
    this.getSyncTime(this.table.name as TableName).then(syncTime => {
      this._syncTime = syncTime;
    });
  }

  /**
   *
   */
  get syncTime(): SyncTime {
    return this._syncTime;
  }

  /**
   *
   * @param items
   */
  public override async set(items: T[]): Promise<void> {
    await super.set(items);
    await this.createOrUpdateTime(this.table.name as TableName);
  }

  /**
   *
   * @param tableName
   */
  private async getSyncTime(tableName: TableName): Promise<SyncTime> {
    const syncTime = await this._syncTimesTable.where('tableName').equals(tableName).first();
    return syncTime ? syncTime : null;
  }

  /**
   *
   * @param tableName
   */
  private async createOrUpdateTime(tableName: TableName): Promise<void> {
    let syncTime = await this.getSyncTime(tableName);
    if(syncTime) {
      syncTime.time = DateTime.local().toISO();
    }
    else {
      syncTime = SyncTimeFactory.new(tableName);
    }
    const id = await this._syncTimesTable.put(syncTime);
    this._syncTime = await this._syncTimesTable.get(id);
  }
}
